import React from 'react'
 import useSEO from "./useSEO";

const Payrollmanagement = () => {
  useSEO({ 
  title: "Payroll Management Services | Expert Payroll Processing in Hyderabad",
  description: "Streamline your payroll process with our professional payroll management services in Hyderabad. We handle salary calculations, statutory compliance, tax deductions, and employee benefits with accuracy and confidentiality.",
  keywords: "payroll management services, payroll processing Hyderabad, salary calculation services, employee payroll outsourcing, statutory compliance payroll, payroll tax deductions, HR payroll solutions, payroll outsourcing company",
  ogTitle: "Payroll Management Services - Trusted Hyderabad Experts",
  ogDescription: "Accurate, compliant, and efficient payroll management services for businesses in Hyderabad.",
  ogImage: "img/payroll-management.png",
  twitterTitle: "Payroll Management Services - Trusted Hyderabad Experts",
  twitterDescription: "Simplify payroll, ensure compliance, and maintain employee satisfaction with our expert payroll management services in Hyderabad.",
  twitterImage: "img/payroll-management.png"
});

  return (
    <div>

        <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Payroll Management Services</h1>
          <p className="mb-4">
            {" "}
            Managing payroll can be time-consuming, complex, and prone to
            errors—especially as regulations and compliance requirements
            continue to evolve. Our Payroll Management Services are designed to
            streamline your payroll process, ensure 100% statutory compliance,
            and allow you to focus on growing your business.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/payroll-management.png"
            alt="Payroll Management Services"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/payroll-management1.png"
              alt="Payroll Management Services"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> What We Offer:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>End-to-End Payroll Processing</b>
                </li>
                <p>
                  From calculating salaries, bonuses, and deductions to
                  generating payslips and disbursing salaries—our solutions
                  cover everything.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Statutory Compliance </b>
                </li>
                <p>
                  We ensure full compliance with EPF, ESI, TDS, Professional
                  Tax, Labour Welfare Fund, and other statutory requirements. No
                  penalties, no worries.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Tax Filing &amp; Reports</b>
                </li>
                <p>
                  We handle accurate and timely filing of monthly, quarterly,
                  and annual tax returns with comprehensive payroll reports.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Employee Self-Service Portal </b>
                </li>
                <p>
                  {" "}
                  Give your employees access to view their payslips, tax
                  declarations, leave balances, and more—anytime, anywhere.{" "}
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Customized Payroll Solutions</b>
                </li>
                <p>
                  {" "}
                  Every business is unique. We offer flexible payroll solutions
                  tailored to your specific industry, workforce size, and
                  internal processes.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

      
    </div>
  )
}

export default Payrollmanagement
